import { useMsal } from '@azure/msal-react';
import { useGoogleAuth } from '../contexts/GoogleAuthContext';

/**
 * Returns true if the current MSAL user is a member of the configured Admin group
 * (REACT_APP_ADMIN_GROUP_ID). Google-authenticated users are always non-admin because
 * they have no Entra group context.
 *
 * The `groups` claim must be enabled on the Entra app registration:
 *   App Registration > Token configuration > Add groups claim > Security groups.
 */
export function useIsAdmin(): boolean {
    const { accounts } = useMsal();
    const { isGoogleAuthenticated } = useGoogleAuth();

    if (isGoogleAuthenticated) {
        return false;
    }

    const adminGroupId = process.env.REACT_APP_ADMIN_GROUP_ID;
    if (!adminGroupId) {
        // No admin group configured: deny by default (fail-closed).
        return false;
    }

    const claims = accounts[0]?.idTokenClaims as Record<string, unknown> | undefined;
    const groups = claims?.['groups'];
    if (!Array.isArray(groups)) {
        return false;
    }

    return (groups as string[]).some(
        (g) => g.toLowerCase() === adminGroupId.toLowerCase()
    );
}
